import { LicenseBadge } from "@nova/ds-component-license-badge"
import { HighPriorityNovaModalContainer } from "@nova/component-nova-modal-container"
import { AddOnIcon } from "plugins/AddonIcon"
import { TableData } from "./useLicensesAndAddonsTableData"

export const SubscriptionActionSelectModal = ({
    title,
    license,
    addOns,
    cancel,
    onSelect,
}: {
    title: "View Invoice" | "Manage Billing Account"
    license: TableData["license"]
    addOns: TableData["addOns"]
    cancel: () => void
    onSelect: (sub: TableData["license"] | TableData["addOns"][number]) => Promise<void>
}) => {
    const bodyText =
        title === "View Invoice"
            ? "Select a subscription to view its invoice."
            : "Select a subscription to manage its billing account."
    return (
        <HighPriorityNovaModalContainer title={title} closeModal={cancel}>
            <div className="flex flex-col gap-3 pt-2.5 min-w-[400px]">
                <div className="text-gray-100">{bodyText}</div>
                <div className="flex flex-col gap-2">
                    {license && (
                        <div
                            className="p-3 flex items-center gap-3 border border-gray-700 rounded-lg cursor-pointer hover:border-white-300 transition-colors"
                            onClick={async () => {
                                await onSelect(license)
                                cancel()
                            }}
                        >
                            <div className="w-8 min-w-[32px]">
                                <LicenseBadge license={license.licenseType} />
                            </div>
                            <div className="grow">{`${license.licenseType[0].toUpperCase()}${license.licenseType.slice(1)} License`}</div>
                        </div>
                    )}
                    {addOns.map((addon) => (
                        <div
                            key={addon.licenseId}
                            className="p-3 flex items-center gap-3 border border-gray-700 rounded-lg cursor-pointer hover:border-white-300 transition-colors"
                            onClick={async () => {
                                await onSelect(addon)
                                cancel()
                            }}
                        >
                            <div className="w-8 min-w-[32px]">
                                <AddOnIcon addOn={addon.addOnType} />
                            </div>
                            <div className="grow">{`${addon.addOnType[0].toUpperCase()}${addon.addOnType.slice(1)}`}</div>
                        </div>
                    ))}
                </div>
            </div>
        </HighPriorityNovaModalContainer>
    )
}
